import { PowerRCIcon } from '~/icons';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { colors } from 'styles/remoteControlColors';
import { ConfirmationContainer } from './styles';

interface ModalOnOffConfirmationProps {
  status: 'on' | 'off';
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ModalOnOffConfirmation: React.FC<ModalOnOffConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
  status,
}) => {
  const { t } = useTranslation();

  const modalInformation = status === 'off' ? {
    title: 'desligarMaquina',
    description: 'desligarMaquinaDescricao',
    color: colors.Red600,
  } : {
    title: 'ligarMaquina',
    description: 'ligarMaquinaDescricao',
    color: colors.Green500,
  };

  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      iconTitle={<PowerRCIcon color={modalInformation.color} />}
      title={t(modalInformation.title)}
      centralizedText
      imageText={(
        <ConfirmationContainer>
          <p>{t(modalInformation.description)}</p>
        </ConfirmationContainer>
      )}
      button1={t('confirmar')}
      button1Action={onConfirm}
      button2={t('cancelar')}
      button2Action={onClose}
    />
  );
};
